import type { ResolveResponse } from "./types";

export interface ProfileTextLabels {
  profile: string;
  biography: string;
  posts: string;
  complete: string;
  partial: string;
  quotedPost: string;
}

export function buildProfileText(result: ResolveResponse, labels: ProfileTextLabels): string {
  if (!result.profile) return "";
  const lines = [
    labels.profile,
    `@${result.author.username}`,
    result.source.canonicalUrl,
    ...(result.profile.biography ? ["", `${labels.biography}: ${result.profile.biography}`] : []),
    "",
    (result.profile.summary.complete ? labels.complete : labels.partial)
      .replace("{count}", String(result.profile.summary.loadedCount)),
    "",
    `${labels.posts} (${result.profile.summary.loadedCount})`
  ];

  result.profile.posts.forEach((post, index) => {
    lines.push("", `--- ${index + 1} ---`, post.publishedAt || "", post.permalink, "", post.text);
    for (const media of post.media) lines.push("", `[${media.type}] ${media.url}`);
    if (post.quotedPost) {
      lines.push("", labels.quotedPost, `@${post.quotedPost.author.username}`, "", post.quotedPost.text);
      for (const media of post.quotedPost.media) lines.push(`[${media.type}] ${media.url}`);
    }
  });

  return lines.filter((line, index, values) => line !== "" || values[index - 1] !== "").join("\n").trim() + "\n";
}
